<app-CadastroAPR [idCliente]="data.idCliente" (close)="closeDialog(true)" [movimento]="data.movimento" [investimento]="data.investimento"></app-CadastroAPR>
